export const languageOption = {
  Arabic: 'ar',
  Bengali: 'bn',
  Bulgarian: 'bg',
  Burmese: 'my',
  'Chinese (Simplified)': 'zh-CN',
  'Chinese (Traditional - Hong Kong)': 'zh-HK',
  Czech: 'cs',
  Danish: 'da',
  Dutch: 'nl',
  English: 'en',
  Filipino: 'fil',
  Finnish: 'fi',
  French: 'fr',
  'French (Canada)': 'fr-CA',
  German: 'de',
  Greek: 'el',
  Hungarian: 'hu',
  Icelandic: 'is',
  Indonesian: 'id',
  Italian: 'it',
  Japanese: 'ja',
  Khmer: 'km',
  Korean: 'ko',
  Lao: 'lo',
  Macedonian: 'mk',
  Malay: 'ms',
  Mongolian: 'mn',
  Norwegian: 'no',
  Polish: 'pl',
  Portuguese: 'pt',
  Romanian: 'ro',
  Russian: 'ru',
  Slovak: 'sk',
  Spanish: 'es',
  Swedish: 'sv',
  Thai: 'th',
  Turkish: 'tr',
  Vietnamese: 'vi',
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/FeedbackFilterGroup/constants.js